import { defineStore } from 'pinia'

export default defineStore("page", {
  state: ()=>({
    stack: [],
    menuOpen: true,
  }),
  getters: {
    title() {
      if (!this.stack.length)
        return "";
      return this.stack[this.stack.length-1].title || "";
    },
    breadcrumbs() {
      if (!this.stack.length)
        return "";
      return this.stack.map(item=>({
        ...(item || {})
      }));
    },
  },
  actions: {
    pushPage(title, link, index) {
//       console.log("Push", title, index);
      if (index!==undefined && index!==null) {
        this.stack[index]={
          title,
          link
        };
        return index;
      } else {
        this.stack.push({
          title,
          link
        });
        return this.stack.length-1;
      }
    },
    replace(title, link, index) {
//       console.log("Replace", title, index);
      if (index===undefined || index===null)
        index=this.stack.length-1;
      this.stack[index]={
        title,
        link
      };
    },
    popPage(obj) {
      if (obj) {
        var objIndex=this.stack.indexOf(obj);
        if (objIndex!=-1)
          this.stack.splice(objIndex, 1);
      } else {
        this.stack.pop();
      }
    },
    saveMenuOpen() {
      if (!this.menuOpen)
        localStorage.setItem("icmsMenuOpen", "1");
      else
        localStorage.removeItem("icmsMenuOpen");
    },
    loadMenuOpen() {
      this.menuOpen=!localStorage.getItem("icmsMenuOpen", "");
    },
  },
});
